import { z } from "zod";

export const DOCUMENT_TYPES = ["lossRuns", "mvr", "ifta"];

export const DOCUMENT_LABELS = {
  lossRuns: "Loss Runs (last 3 years)",
  mvr: "MVRs (one for each driver)",
  ifta: "IFTA (last 4 quarters)",
};

export const REQUIRED_TYPES = ["lossRuns", "mvr"];

const normalizeCarriers = (carriers) =>
  (Array.isArray(carriers) ? carriers : carriers ? [carriers] : []).map((c) =>
    String(c ?? "").toLowerCase()
  );

export const getRequiredDocumentTypes = (data = {}) => {
  const carriers = normalizeCarriers(data?.step1?.carrier ?? data?.carriers);
  const vehicleCount =
    data?.vehicleCount ?? data?.step6?.vehicles?.length ?? 0;
  const required = new Set();

  if (vehicleCount >= 6 || carriers.includes("nirvana")) {
    required.add("lossRuns");
  }

  if (carriers.includes("accelerant") || carriers.includes("corgi trucking")) {
    REQUIRED_TYPES.forEach((type) => required.add(type));
    required.add("ifta");
  }

  return DOCUMENT_TYPES.filter((type) => required.has(type));
};

const DocumentSchema = z.object({
  type: z.enum(DOCUMENT_TYPES, { required_error: "Document type is required" }),
  url: z.string().min(1, "Document URL required"),
  name: z.string().optional(),
  id: z.union([z.string(), z.number()]).optional(),
});

export const Step10Schema = z.object({
  documents: z.array(DocumentSchema).default([]),
  targetPricePerTruck: z.string().optional(),
});
